export const TextConstants = {
    login:'Login',
    empId: 'Emp Id',
    empName:'Emp Name',
    password:'Password',
    dashboard:'Dashboard',
    home:'Home',
    profile:'Profile',
    role:'Role',
    approvals:'Approvals',
    logout:'Logout',
    logoutAlert:'Are you sure you want to logout?',
    yes:'Yes',
    no:'No',
    cancel:'Cancel',
    submit:'Submit',
    pending:'Pending',
    approve:'Approve',
    inr:'₹',
    dealerListTitle:'Dealer Data',
    painterListTitle:'Painter Data',
    productListTitle:'Product Data',
    painterDetails:'Painter Details',
    productDetails:'Product Details',
    processOrderReport:'Process Order Report',
    FileUpload:'File Upload',
    processOrder:'Process Order',
    scheme:'Scheme'

}

export const TableTextConstants = {
    sino:'SI No',
    date:'Date',
    dealerName:'Dealer Name',
    dealerCode:'Dealer Code',
    status:'Status',
    action:'Action',
    totalAmount:'Total Amount',
    amount:'Amount',
    handlingFee:'Handling Fee',
    nodata:'No data available',
    view:'View',
    painterName:'Painter Name',
    productname:'Product Name',
    qrCode:'QR Code',
    paintermobile:'Painter Mobile',
    CreditNoteNumber:'CN Number',
    processOrderNumber:'Process Order Number',
    batchNumber:'Batch Number',
    tokenGeneratedCount:'Token Generated Count',
    tokenScannedCount:'Token Scanned Count',
    city:'City',
    state:'State'
}